import { render, staticRenderFns } from "./QueueManagement.vue?vue&type=template&id=1ef03372"
import script from "./QueueManagement.vue?vue&type=script&lang=js"
export * from "./QueueManagement.vue?vue&type=script&lang=js"
import style0 from "./QueueManagement.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports